import React from 'react';

import ChartAxis from '../../../../library/chart-axis/chart-axis';

import './ride-data-info-chart-line.scss';

interface RideDataInfoChartLineProps {
  hideTickLabels?: boolean;
  label: string;
  value: number;
}

function RideDataInfoChartLine(props: RideDataInfoChartLineProps) {
  const { hideTickLabels = false, label = '', value = 0 } = props;

  const min = 1;
  const max = 5;
  const left = Math.max((value - 1) * 25, 0);

  return (
    <div styleName="container">
      <span styleName="label">{label}</span>
      <div styleName="chart">
        <span style={{ left: `${left}%` }} styleName="value" />
        <ChartAxis
          hideTickLabels={hideTickLabels}
          increment={1}
          max={max}
          min={min}
        />
      </div>
    </div>
  );
}

export default RideDataInfoChartLine;
